import { call, put, select } from 'redux-saga/effects';

import { updatePatient } from 'connect/actions';
import { extractErrorMessage, sendToLogger } from 'connect/saga/helpers';
import { getPatient } from 'connect/saga/saga';
import { selectDataPatient } from 'connect/selectors';
import { apiUpdatePatient } from 'endpoints/patient-endpoints';

import { SagaHandler } from '../SagaHandler';

class _UpdatePatientDetails extends SagaHandler {
  constructor() {
    super({
      actionName: 'data/UPDATE_PATIENT_DETAILS',
      stateKey: 'updatePatientDetails',
    });
  }

  createAction(patientDetails, autoVerify = false) {
    return {
      type: this._actionName,
      patientDetails,
      autoVerify,
    };
  }

  *saga({ patientDetails, autoVerify }) {
    const errorHandler = this.error;
    const loadingHandler = this.loading;
    const successHandler = this.success;

    let patient = yield select(selectDataPatient);

    if (!patient?.id) {
      patient = yield call(getPatient);
    }

    const isLoading = yield select(loadingHandler.selector);
    if (isLoading) {
      return;
    }

    yield put(loadingHandler.update(true));
    yield put(errorHandler.update(null));
    yield put(successHandler.update(null));

    try {
      const updatedPatient = yield call(
        apiUpdatePatient,
        patient.id,
        patientDetails,
        autoVerify,
      );

      yield put(updatePatient(updatedPatient));
      yield put(successHandler.update(true));
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      yield put(errorHandler.update(errorMessage));
      sendToLogger(error, 'UpdatePatientDetails');
    } finally {
      yield put(loadingHandler.update(false));
    }
  }
}

export const UpdatePatientDetails = new _UpdatePatientDetails();
